import React from 'react';
import Intro from '../Intro/Intro';
import './Header.css'

const Header = () => {
    return (
        <div className='bgColor'>
            <Intro></Intro>
        </div>
    );
};

export default Header;